import './Footer.scss';

const Footer = () => {
  return (
      <footer className="footer py-2 d-none d-sm-block">
        <div className="container container-fluid">
          <div className="copyright">Copyright © {new Date().getFullYear()}</div>
        </div>
      </footer>
  );
};

export default Footer;
